<template>
  <RouterView />
  <vue-loading-indicator />
</template>

<script setup>
import { useLoadingIndicator } from '@nguyenshort/vue3-loading-indicator';
import router from './router';

const $loading = useLoadingIndicator();

router.beforeEach((to, from, next) => {
  $loading.start();
  next();
});

router.afterEach(() => {
  $loading.finish();
});
</script>

<style lang="scss">
// Main Stylesheet
@use "@/assets/scss/main";

// All color themes are included and available by default

@use "@/assets/scss/oneui/themes/modern";

.vue-process-bar {
  position: fixed !important ;
  height: 10px !important;
  z-index: 9999 !important; /* Ensure it's on top */
  height: 3px !important; /* Set explicit height */
  opacity: 1 !important;
}
</style>